import Highcharts from "highcharts/highcharts";
import ViewController from "core/views/view.controller";
import {Colors} from "main/main.config";

export default class ChartBookingProgressCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);

        this.chart = null;
        this.bookingCounts = {
            open: 0,
            finished: 0
        };

        // Bindings
        this.bookings = [];
    }

    $onInit() {
        if (!this.chart) {
            this.createChart();
        }
    }

    $onChanges(changes) {
        if (!changes.bookings) {
            return;
        }

        if (!changes.bookings.currentValue || !changes.bookings.currentValue.length) {
            this.bookings = [];
        }

        if (!this.chart) {
            this.createChart();
        }

        this.updateBookingCounts();
        this.updateChart();
    }

    createChart() {
        this.chart = Highcharts.chart('chart-booking-progress-hs', {
            chart: {
                type: 'pie',
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                spacingBottom: 10,
                spacingTop: 0,
                spacingLeft: 0,
                spacingRight: 0,
            },

            title: {
                text: '',
                align: 'center',
                verticalAlign: 'middle',
                y: 5,
                style: {
                    color: Colors.textNormal,
                    fontSize: "18px",
                    fontWeight: '600',
                    fontFamily: '-apple-system, "Helvetica Neue", Roboto, "Segoe UI", sans-serif'
                }
            },

            tooltip: {
                enabled: false
            },

            plotOptions: {
                pie: {
                    shadow: false,
                    center: ['50%', '50%'],
                    dataLabels: {
                        enabled: false
                    }
                },

                series: {
                    enableMouseTracking: false
                }
            },

            series: [{
                innerSize: '60%',
                data: this.createData(0, 0)
            }]
        });
    }

    updateChart() {
        var totalBookings = this.bookingCounts.finished + this.bookingCounts.open;
        var finishedPct = totalBookings > 0 ? Math.round((this.bookingCounts.finished * 100) / totalBookings) : 0;

        this.chart.setTitle({text: finishedPct + '%'}, null, true);

        this.chart.series[0].setData(this.createData(
            this.bookingCounts.finished,
            this.bookingCounts.open));

        this.chart.setSize(null, null, false);
    }

    createData(finishedCount, openCount) {
        return [{
            name: 'Finished',
            y: finishedCount,
            color: Colors.highlight1
        }, {
            name: 'Open',
            y: openCount,
            color: Colors.bg
        }]
    }

    updateBookingCounts() {
        this.bookingCounts.open = 0;
        this.bookingCounts.finished = 0;

        this.bookings.forEach((booking)=> {
            if (booking.isOpen()) {
                this.bookingCounts.open++;
            } else {
                this.bookingCounts.finished++;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-progress/chart-booking-progress.controller.js